/**
 * Aviso de que las noticias han cambiado.
 *
 * ⚠️ Esta web es SOLO LECTURA (`newsService.ts` no tiene ningún
 * create/update/delete): hoy nada llama a `avisarCambioEnNoticias`, así que
 * `useNoticiasPublicas` está suscrito a un canal que nunca suena. Se deja tal
 * cual — es barato e inofensivo — por si algún día esta web vuelve a tener
 * algo que escriba en el mismo origen; si no, es candidato a limpieza.
 */

type Escucha = () => void;

const escuchas = new Set<Escucha>();

/**
 * Canal para avisar también a las demás pestañas del mismo navegador.
 *
 * El caso real: el editor tiene el panel abierto en una pestaña y la web en
 * otra. Sin esto, la segunda no se enteraría hasta navegar o recargar.
 *
 * Se comprueba que exista porque no está en todos los entornos donde corre
 * este código (algunos runners de test no lo traen).
 */
const canal =
  typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel('solimat-noticias');

if (canal) {
  canal.onmessage = () => {
    escuchas.forEach((escucha) => escucha());
  };
}

/**
 * Se apunta a los cambios. Devuelve la función para darse de baja, que es lo
 * que espera `useEffect` como limpieza.
 */
export function suscribirseANoticias(escucha: Escucha): () => void {
  escuchas.add(escucha);

  return () => {
    escuchas.delete(escucha);
  };
}

/** Avisa a esta pestaña y a las demás de que hay que releer las noticias. */
export function avisarCambioEnNoticias(): void {
  escuchas.forEach((escucha) => escucha());
  canal?.postMessage('cambio');
}
